import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Trademark } from '@cp/ds/src/components/trademark';
import loadable from '@loadable/component';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { useMediaQuery } from '@mui/material';
import { Button } from '@cp/ds/src/components/button';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { CitiesListLink, CitySelectionButton } from 'src/features/location';
import { EButtonName } from 'src/shared/tracking';
import { useClientLogin } from 'src/features/client/current/login';
import { HeaderFeature, useSyncDimensions } from '../model';
import { HeaderContentProps } from './model';

const NavigateToCatalogLink = loadable(() => import('src/features/catalog/ui/navigateLink').then((module) => module.default));
const ClientDashboard = loadable(() => import('src/widgets/client/current/dashboard'));
const ClientMenu = loadable(() => import('src/widgets/client/current/menu'));

export const HeaderContentDesktop: React.FC<HeaderContentProps> = ({
  features,
  trademarkSize,
  onLogoClick,
  clientProfile,
  rightBlock,
  leftBlock,
  containerRef,
}) => {
  const theme = useTheme();
  const isXxlScreen = useMediaQuery(theme.breakpoints.up('xxl'));
  const height = useSyncDimensions(containerRef);
  const login = useClientLogin();

  return (
    <>
      <Stack alignItems="center" direction="row">
        <Link disableHover onClick={onLogoClick} underline={false}>
          {/* eslint-disable-next-line @typescript-eslint/no-magic-numbers */}
          <Trademark size={trademarkSize ?? (isXxlScreen ? 3.164375 : 2.125)} />
        </Link>
        {features[HeaderFeature.CitiesList] ? <CitiesListLink /> : null}
        {features[HeaderFeature.CitySelection] ? <CitySelectionButton /> : null}
        {features[HeaderFeature.NavigateToCatalog] ? <NavigateToCatalogLink sx={{ ml: 6.25 }} /> : null}
        {leftBlock}
      </Stack>
      {rightBlock}
      {features[HeaderFeature.ClientMenu] && clientProfile ? (
        <ClientMenu absoluteTopPosition={height}>
          {({ ref, isMenuOpened, toggleMenu }) => (
            <ClientDashboard
              isProfileButtonActive={isMenuOpened}
              onProfileButtonClick={toggleMenu}
              ref={ref as React.Ref<HTMLDivElement> | undefined}
            />
          )}
        </ClientMenu>
      ) : null}
      {features[HeaderFeature.LoginButton] && !clientProfile ? (
        <Button className={EButtonName.Login} onClick={() => login()} size="small" variant="secondary">
          Войти
        </Button>
      ) : null}
    </>
  );
};
